import { render, staticRenderFns } from "./widgetSlider.vue?vue&type=template&id=60c0c3ed&scoped=true"
import script from "./widgetSlider.vue?vue&type=script&lang=js"
export * from "./widgetSlider.vue?vue&type=script&lang=js"
import style0 from "./widgetSlider.vue?vue&type=style&index=0&id=60c0c3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c0c3ed",
  null
  
)

export default component.exports